<section class="pb-sm-5 about-bot">
    <div class="container">
        <div class="sec-inner-sec about-bots">
            <div class="sec-head">
                <h1 class="sec-title text-capitalize">{{title}}</h1>
                <span class="block"></span>
            </div>
            <div class="about_strivel position-relative">
                <div class="profile-wrapper">
                    <div class="profile-image">
                        <img [src]="image.background" alt="about _image" class="img-fluid" />
                    </div>
                    <h2 class="profile-title">{{name.first}}
                        <span>{{name.last}}</span>
                    </h2>
                    <div class="profile-info">
                        <div class="content">
                            <div class="row  pro-contact">
                                <div class="col-4">
                                    <img [src]="image.profile" alt="" class="rounded-circle img-fluid">
                                </div>
                                <div class="col-sm-8  my-auto">
                                    <div class="link_about my-2" *ngFor="let contactDetail of contactDetails">
                                        <i [ngClass]="[contactDetail.icon]" aria-hidden="true"></i>
                                        <a [href]="contactDetail.link" target="_blank">{{contactDetail.text}}</a>
                                    </div>
                                </div>
                            </div>
                            <p *ngFor="let desc of descriptions" class="mb-0">{{desc}}</p>
                            <p class="my-1">My responsibilities include - </p>
                            <ul class="ml-3">
                                <li *ngFor="let res of responsibilities">{{res}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>